import { ColumnBase } from "./ColumnBase/ColumnBase";
import { ColumnAccessor } from "./ColumnAccessor/ColumnAccessor";
import { ColumnFiller } from "./ColumnFiller/ColumnFiller";

export const Column = {
  Base: ColumnBase,
  Accessor: ColumnAccessor,
  Filler: ColumnFiller,
};
